import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 20,
};

export const teachersListTableControllerSlice = createSlice({
    name: 'teachersListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = teachersListTableControllerSlice.actions;

export default teachersListTableControllerSlice.reducer;